import {Injectable} from '@angular/core';
import dd from '../dashboard/data.json';

@Injectable({
  providedIn: 'root'
})
export class DashboardService {

  constructor() {
  }

  kpiData(name: string): any {
    if (dd.hasOwnProperty(name)) {
      return dd[name];
    }
    return null;
  }
}
